<template>
  <svg
    width="81"
    height="80"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.1818 15.2131C56.1818 14.4539 55.2492 14.0901 54.7352 14.6489L30.8161 40.6479C30.3247 41.182 30.7036 42.0454 31.4294 42.0454H38.6818C41.9034 42.0454 44.5151 44.6571 44.5151 47.8788V64.4618C44.5151 65.2313 45.4689 65.5897 45.9756 65.0106L67.1146 40.8518C67.586 40.313 67.2034 39.4697 66.4874 39.4697H62.0151C58.7935 39.4697 56.1818 36.858 56.1818 33.6364V15.2131ZM51.0555 11.2636C54.654 7.35223 61.1818 9.89821 61.1818 15.2131V33.6364C61.1818 34.0966 61.5549 34.4697 62.0151 34.4697H66.4874C71.4992 34.4697 74.1777 40.3726 70.8774 44.1443L49.7385 68.3031C46.1916 72.3567 39.5151 69.8481 39.5151 64.4618V47.8788C39.5151 47.4185 39.142 47.0454 38.6818 47.0454H31.4294C26.3487 47.0454 23.6966 41.0016 27.1364 37.2626L51.0555 11.2636ZM4.66663 15.7576C4.66663 14.3769 5.78591 13.2576 7.16663 13.2576H31.4091C32.7898 13.2576 33.9091 14.3769 33.9091 15.7576C33.9091 17.1383 32.7898 18.2576 31.4091 18.2576H7.16663C5.78591 18.2576 4.66663 17.1383 4.66663 15.7576ZM4.66663 40C4.66663 38.6193 5.78591 37.5 7.16663 37.5H19.2878C20.6686 37.5 21.7878 38.6193 21.7878 40C21.7878 41.3807 20.6686 42.5 19.2878 42.5H7.16663C5.78591 42.5 4.66663 41.3807 4.66663 40ZM4.66663 64.2424C4.66663 62.8617 5.78591 61.7424 7.16663 61.7424H28.3787C29.7595 61.7424 30.8787 62.8617 30.8787 64.2424C30.8787 65.6231 29.7595 66.7424 28.3787 66.7424H7.16663C5.78591 66.7424 4.66663 65.6231 4.66663 64.2424Z"
      fill="#0081FF"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss"></style>
